import * as React from 'react';
import cn from 'classnames';
import './style.scss';
import { SearchServiceInputProps } from './SearchServiceInputProps';

const SearchServiceInput: React.FC<SearchServiceInputProps> = ({
  isFocused,
  isFilled,
  inputProps,
  clearHandler,
  searchHandler,
}) => {
  return (
    <label
      htmlFor="mos-catalog-search-input"
      className={cn('mos-catalog-search-input__wrapper', {
        'mos-catalog-search-input__wrapper--filled': isFilled,
        'mos-catalog-search-input__wrapper--focused': isFocused,
      })}
    >
      <div className="mos-catalog-search-input__placeholder" aria-hidden="true">
        Найти услугу
      </div>
      <input
        {...inputProps}
        type="text"
        aria-label="Введите название"
        id="mos-catalog-search-input"
      />
      <div
        className="mos-catalog-search-input__clear"
        role="button"
        aria-label="Очистить поле"
        onClick={clearHandler}
      />
      <div
        className="mos-catalog-search-input__magnify"
        role="button"
        aria-label="Открыть результаты"
        onClick={searchHandler}
      />
    </label>
  );
};

export default SearchServiceInput;
